import axios from 'axios';

// create an axios instance
const $http = axios.create({
  baseURL: process.env.BASE_API,// api的base_url
  timeout: 5000 // request timeout
});

// request interceptor
$http.interceptors.request.use(config => {
  // Do something before request is sent
  // if (store.getters.token) {
  // config.headers['TOKEN_SESSION'] = '70mq0se82pcnomt0ov16j0c2tr'; 
  // }
  return config;
}, error => {
  // Do something with request error
  console.log(error); // for debug
  Promise.reject(error);
});

export default $http;
